var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',_vm._b({staticClass:"ae-input-range",class:[_vm.fill],attrs:{"type":"range"},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit($event.type, +$event.target.value)}}},'input',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }